var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSolutionLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Solution Certification",
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 119.998
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 5523",
  d: "M0 0h120v119.998H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10620",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 10621"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280300",
  d: "M96.384 23.493H68.757a8.007 8.007 0 0 0-8.387 7.647v.987H28.304a6.886 6.886 0 0 0-7.153 6.66v39.96h-1.727a4.422 4.422 0 0 0-4.44 4.439v4.687a9.129 9.129 0 0 0 9.62 8.633H94.41a9.282 9.282 0 0 0 9.62-8.633v-4.687a4.586 4.586 0 0 0-4.44-4.44h-1.726v-21.46a7.6 7.6 0 0 0 7.153-7.647V31.386c-.74-4.687-4.44-8.14-8.633-7.893m2.467 63.886a4.355 4.355 0 0 1-4.687 3.7H24.357a4.355 4.355 0 0 1-4.687-3.7v-4.193h27.38a5.332 5.332 0 0 0 5.427 4.44h13.567a5.332 5.332 0 0 0 5.427-4.44h27.38Zm-32.313-8.88v4.193c-.247.247-.247.247-.493.247H52.477c-.247 0-.493-.247-.493 0v-4.44h-25.9V38.54a1.993 1.993 0 0 1 2.22-1.727h32.067v12.58a8.007 8.007 0 0 0 8.387 7.647h.74v7.4a2.37 2.37 0 0 0 1.48 2.22 1.483 1.483 0 0 0 .987.247 4.573 4.573 0 0 0 1.727-.493l10.358-9.128h8.634v21.46ZM99.59 49.393a3.069 3.069 0 0 1-3.453 2.713h-13.32a4.573 4.573 0 0 0-1.727.493l-6.906 6.168v-4.44a2.33 2.33 0 0 0-2.467-2.467H68.51a3.069 3.069 0 0 1-3.453-2.713V30.893a3.069 3.069 0 0 1 3.453-2.713h27.627a3.069 3.069 0 0 1 3.453 2.713Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280301",
  d: "M91.451 37.307a3.207 3.207 0 1 0 3.207 3.207 3.447 3.447 0 0 0-3.207-3.207"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280302",
  d: "M82.325 37.307a3.207 3.207 0 1 0 3.207 3.207 3.265 3.265 0 0 0-3.207-3.207"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280303",
  d: "M73.444 37.307a3.207 3.207 0 1 0 3.207 3.207 3.265 3.265 0 0 0-3.207-3.207"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280304",
  d: "M46.558 60.741a10.113 10.113 0 1 0-10.113-10.114 10.159 10.159 0 0 0 10.113 10.114m0-15.54a5.18 5.18 0 1 1-5.18 5.18 5.21 5.21 0 0 1 5.18-5.18"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 280305",
  d: "M53.465 62.713H39.652a8.843 8.843 0 0 0-8.88 8.88V74.8h4.933v-3.207a3.9 3.9 0 0 1 3.947-3.947h13.813a3.9 3.9 0 0 1 3.947 3.947V74.8h4.933v-3.207a8.843 8.843 0 0 0-8.88-8.88"
})))));
export default SvgSolutionLogo;